type NavigateFn = (path: string) => void;

let _navigate: NavigateFn = (path) => {
  window.location.href = path;
};

export const setNavigate = (fn: NavigateFn) => {
  _navigate = fn;
};

export const navigateTo = (path: string) => _navigate(path);
